import ASIMOV_EXT_1 from "./ASIMOV_EXT_1";
export default {
  ASIMOV_EXT_1,
};
